module.exports = __webpack_public_path__ + "img/afcfta.e748d5f0.png";